import { actionTypes } from "./action-types";
import { mutationTypes } from "./mutation-types";
import { getterTypes } from "./getter-types";
import { validateMessages } from "@/config";
import {
  fetchProducts,
  fetchCategories,
  fetchProductConfig,
  fetchProductsByCode,
  fetchProductCodeConfig,
  saveProductCodeConfig,
  deleteFileProductCodeConfig,
  getVariant,
} from "@/services/products";

import Vue from "vue";

const ProductsModule = {
  namespaced: true,
  strict: true,
  state: {
    products: [],
    categories: [],
    product_config: [],
    product_code_config: [],
    variant: null,
  },
  actions: {
    [actionTypes.FETCH_PRODUCTS]({ commit }, slug) {
      return new Promise((resolve, reject) => {
        fetchProducts(slug)
          .then((response) => {
            commit(mutationTypes.SET_PRODUCTS, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.FETCH_PRODUCT_BY_CODE]({ commit }, code) {
      return new Promise((resolve, reject) => {
        fetchProductsByCode(code)
          .then((response) => {
            const products = {
              items: [response.data],
            };
            commit(mutationTypes.SET_PRODUCTS, products);
            resolve(products);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.ADD_VARIANT]({ commit }, data) {
      return new Promise((resolve, reject) => {
        getVariant(data.code, data.codes)
          .then((response) => {
            commit(mutationTypes.SET_VARIANT, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.FETCH_CATEGORIES]({ commit }) {
      return new Promise((resolve, reject) => {
        fetchCategories()
          .then((response) => {
            commit(mutationTypes.SET_CATEGORIES, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.FETCH_PRODUCT_CONFIG]({ commit }, name) {
      return new Promise((resolve, reject) => {
        fetchProductConfig(name)
          .then((response) => {
            commit(mutationTypes.SET_PRODUCT_CONFIG, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.FETCH_PRODUCT_CODE_CONFIG]({ commit }, code) {
      return new Promise((resolve, reject) => {
        fetchProductCodeConfig(code)
          .then((response) => {
            commit(mutationTypes.SET_PRODUCT_CODE_CONFIG, response.data);
            resolve(response.data);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.SAVE_PRODUCT_CODE_CONFIG]({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        saveProductCodeConfig(data)
          .then(async(response) => {
            const code = {
              productCode: data.productCode,
              configCode: data.configCode,
            };
            if (data.itemId) {
              code.itemId = data.itemId;
            }
            await dispatch(actionTypes.FETCH_PRODUCT_CODE_CONFIG, code);
            resolve(response);
          })
          .catch(() => {
            reject(validateMessages.error);
          });
      });
    },
    [actionTypes.DELETE_FILE_PRODUCT_CODE_CONFIG]({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        deleteFileProductCodeConfig(data)
          .then(async(response) => {
            const code = {
              productCode: data.productCode,
              configCode: data.configCode,
            };
            await dispatch(actionTypes.FETCH_PRODUCT_CODE_CONFIG, code);
            Vue.notify({
              group: validateMessages.group,
              type: "success",
              text: "Plik został usunięty.",
            });
            resolve(response.data);
          })
          .catch(() => {
            Vue.notify({
              group: validateMessages.group,
              type: "error",
              text: "Wystąpił błąd podczas usuwania pliku",
            });
            reject(validateMessages.error);
          });
      });
    },
  },
  mutations: {
    [mutationTypes.SET_PRODUCTS](state, payload) {
      state.products = payload;
    },
    [mutationTypes.SET_CATEGORIES](state, payload) {
      state.categories = payload;
    },
    [mutationTypes.SET_PRODUCT_CONFIG](state, payload) {
      state.product_config = payload;
    },
    [mutationTypes.SET_PRODUCT_CODE_CONFIG](state, payload) {
      state.product_code_config = payload;
    },
    [mutationTypes.SET_VARIANT](state, payload) {
      state.variant = payload;
    },
  },
  getters: {
    [getterTypes.GET_PRODUCTS](state) {
      return state.products;
    },
    [getterTypes.GET_CATEGORIES](state) {
      return state.categories;
    },
    [getterTypes.GET_PRODUCT_CONFIG](state) {
      return state.product_config;
    },
    [getterTypes.GET_PRODUCT_CODE_CONFIG](state) {
      return state.product_code_config;
    },
    [getterTypes.GET_VARIANT](state) {
      return state.variant;
    },
  },
};

export { ProductsModule };
